export class WizardSessionDTO{
    public id!: number;
    public userId!: number;
    public sessionData!: string;
    public added!: string;
    public edited!: string;
    public sessionFinalized!: boolean;
}